export const CUSTOMER_ENDPOINTS = {
  USERS: 'api/portal-admin/customers',
  CREATE_CUSTOMER: '/api/stripe/customer/create',
  CUSTOMERS_LIST :"api/portal-admin/customerslist",
  CUSTOMER_STATUS: '/customers/stats',
  CUSTOMER_BY_ID: (id: string) => `api/portal-admin/customers/${id}`,
  UPDATE_CUSTOMER: (id: string) => `api/portal-admin/customers/${id}/edit`,
  DELETE_CUSTOMER: (id: string) => `api/portal-admin/customers/${id}/delete`,
  CANCEL_SUBSCRIPTION: `api/portal-admin/customer/subscription/delete`,
  // Usage endpoints
  USAGE_DAILY: (id: string, date: string) =>
    `api/portal-admin/usage/${id}/daily/${date}`,
  USAGE_MONTHLY: (id: string, year: number, month: number) =>
    `api/portal-admin/usage/${id}/monthly/${year}/${month}`,
  USAGE_YEARLY: (id: string, year: number) =>
    `api/portal-admin/usage/${id}/yearly/${year}`,
  CUSTOMER_TELEMETRY: (id: string) => `api/portal-admin/usage/${id}/telemetry`,
  GIFT_ENERGY: (id: string) => `api/portal-admin/customers/${id}/send-gift`,
  TRANSACTION_LISTING:(id:string)=>`api/portal-admin/customer/transaction-listing/${id}`,
  PRODUCT_PURCHASES: (id: string) =>
    `api/portal-admin/customers/${id}/product-purchases`,
  UPLOAD_POA:'api/portal-admin/upload-vollmacht',
  BEXIO_CONVERT_COMPANY_CONTACTS:
    'api/portal-admin/bexio/contacts/convert-companies-to-persons',
} as const;
